<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="false" color="#007BFF" loader="dots"></loading>
    <div class="vx-row" style="margin-bottom: 55px;">
      <div class="vx-col w-full sm:w-full md:w-full flex flex-col">
        <vue-apex-charts type="donut" height="450" class="xs" :options="gchartOptions" :series="gseries" />
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import covidApi from '@/http/requests/covid/index.js'

const numeral = require('numeral')

export default {
  name: 'GhanaDonut',
  components: {
    Loading,
    VueApexCharts
  },
  computed: {
    isLoading() {
      return this.isLoadingG
    }
  },
  data() {
    return {
      strains: [],
      gseries: [],
      gchartOptions: {
        labels: [],
        colors: ['#008cff', '#28C76F', '#EA5455', '#7193FF', '#FF9F43', '#e5ff00', '#1E1E1E', '#4b9484', '#af9d6a'],
        dataLabels: {
          enabled: false
        },
        legend: { show: true, position: 'right' },
        tooltip: {
          y: {
            formatter(val, w) {
              const sum = w.globals.seriesTotals.reduce((a, b) => {
                return a + b
              }, 0)
              const x = sum === 0 ? 0 : Math.round((val / sum) * 100)
              return `${x}%`
            }
          }
        },
        chart: {
          offsetY: 80,
          type: 'donut',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          pie: {
            customScale: 1.0,
            donut: {
              labels: {
                show: true,
                name: { show: true },
                value: {
                  show: true,
                  formatter(val) {
                    return numeral(val).format('0,000')
                  }
                },
                total: {
                  showAlways: true,
                  label: 'Ghana',
                  show: true
                }
              }
            }
          }
        },
        stroke: { width: 0 }
      },
      start: '2020-03-01',
      end: new Date().toISOString().slice(0, 10),
      isLoadingG: false
    }
  },
  created() {
    this.getStrains()
  },
  methods: {
    getStrains() {
      const self = this
      this.strains = []
      covidApi
        .strains()
        .then(response => {
          self.strains = response.data
          self.getData()
        })
        .catch(error => {
          console.log(error)
        })
    },
    getData() {
      const self = this
      this.gseries = []
      this.isLoadingG = true
      covidApi
        .bigpie({ region: 'All', start: this.start, end: this.end })
        .then(response => {
          self.gseries = response.data.series
          self.gchartOptions = {
            ...self.gchartOptions,
            labels: self.strains
          }
          this.isLoadingG = false
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
